import {USER_AREAS_FETCHED, USER_SELECTED_AREA, USER_FILTERED_AREA, CLEAR_AREA_SELECTION} from '../../actions/types';


export default function(state = [], action){
    switch (action.type){
        case USER_AREAS_FETCHED:
            return {list:action.payload};
        case USER_SELECTED_AREA:
            return {...state,selectedArea:action.payload};
        case USER_FILTERED_AREA:
            return {...state, filteredArea:action.payload};
        case CLEAR_AREA_SELECTION:
            return {...state,selectedArea:0};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Areas/index.js